import React from "react";

import SectionFigure from "./SectionFigure";

export default function JsSection(props) {
  return (
    <>
      <section className="section-spacing" id={props.sectionID}>
        <div className="container">
          <h2 className="heading-secondary">{props.sectionHeading}</h2>

          <div className="container-figure">
            <div className="grid grid--2-cols grid--2-rows">
              <SectionFigure
                heading="Notes App"
                listItem1="Store all notes and important information digitally"
                listItem2="Notes stored in your device's storage"
                listItem3="Access your written data anytime using your device"
                appURL="https://jayant-notes.netlify.app/"
              />

              <SectionFigure
                figGridPlacement="row-2--col-2"
                heading="Todo App"
                listItem1="A Task Management app to keep you organised"
                listItem2="Make a shopping list or task list"
                listItem3="Plan an event and set reminders"
                appURL="https://jayant-todo.netlify.app/"
              />

              <SectionFigure
                figGridPlacement="row-3--col-1"
                heading="Hangman App"
                listItem1="Just a fun word guessing game"
                listItem2="Word to guess is represented by row of dashes"
                listItem3="A fun game that increases mental performance"
                appURL="https://jayant-hangman.netlify.app/"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
